export default {
    versionHistory: [],
    isVersionHistoryLoaded: false,
    versionHistoryItem: {},
    isVersionHistoryItemLoaded: false,
    isVersionHistoryItemSaving: false,
    latestVersionHistorySavedItem: {},
};
